module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// AnchorNavigator Widget

(function (fox, $) {
	
	fox.registerWidget('AnchorNavigator', {

		init: function () {
			this.addDomHandler({
				event: 'click',
				target: this.requireOption('clickTarget'),
				targetWidget: this.requireOption('targetWidget'),
				callback: 'navigate'
			}, 'navigate');
		
			this.callParent('init', arguments);
		},

		navigate: function (el, evAlias, performer) {
			var id, $el, $target, dopOffsetTop = this.getOption('dopOffsetTop') || 0;

			$el = $(el);
			id = $el.data('target');
			$target = $(performer.dom1(['#', id].join('')));

			$el.parent()
				.find('.active')
				.removeClass('active');

			$el.addClass('active');

			if (dopOffsetTop) {
				dopOffsetTop = isNaN(parseInt(dopOffsetTop)) ? $(dopOffsetTop).outerHeight(true) : parseInt(dopOffsetTop);
			}

			if ($target) {
				$('body, html').animate({
					scrollTop: $target.offset().top - dopOffsetTop
				}, 500);
			}
		}

	}, 'Controller');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/anchorNavigator.js
// module id = 293
// module chunks = 2